module.exports = __webpack_public_path__ + "static/img/5-7.be8e3eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/5-7.png
// module id = 278
// module chunks = 0